<template>
  <div class="work-audio">
    <aplayer :music="audio" :autoplay="true" ref="player"></aplayer>
  </div>
</template>

<script>
import Aplayer from "vue-aplayer";
// const music_url = require("../../../../assets/file/阿吉太组合 - 阿衣莫.mp3");
export default {
  components: {
    Aplayer,
  },
  props: {
    data: Object,
  },
  data() {
    return {
      audio: {
        src: 'aa',
        title: "测试音频",
      },
    };
  },
  watch: {
    data: {
      handler(val) {
        console.log("watch", val);
        // this.audio.src = val.file;
        // this.audio.title = val.name;
        this.audio = {
          src: val.file,
          title: val.name,
          artist: val.username,
          pic: val.image[0]
        }
      },
    },
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.work-audio {
}
</style>
